module.exports = __webpack_public_path__ + "img/enemy_112_003.8c6a6153.png";